import React, { useMemo } from 'react';
import classNames from 'classnames';
import ShareableLinkLockScreen from '../ShareableLinkLockScreen';
import { useTranslation } from 'react-i18next';
import WaitingImage from 'assets/images/members.webp';
import { getJoinedWordsWithComma } from 'utils';

import './ShareableLinkWaitingRoom.styles.scss';

type ShareableLinkWaitingRoomProps = {
  className?: string;
  isEmailNotificationTurnOn?: boolean;
  isSMSNotificationTurnOn?: boolean;
  isPlatformNotificationTurnOn?: boolean;
};

const ShareableLinkWaitingRoom: React.FC<ShareableLinkWaitingRoomProps> = (
  props,
) => {
  const {
    className,
    isEmailNotificationTurnOn,
    isSMSNotificationTurnOn,
    isPlatformNotificationTurnOn,
  } = props;

  const classes = classNames('shareable-link-waiting-room', className);

  const { t } = useTranslation();

  const communications = useMemo(() => {
    const txt = [];

    if (isEmailNotificationTurnOn) txt.push(t('emailLC'));

    if (isSMSNotificationTurnOn) txt.push(t('sms'));

    if (isPlatformNotificationTurnOn) txt.push(t('platformNotification'));

    return getJoinedWordsWithComma(txt);
  }, [
    isEmailNotificationTurnOn,
    isPlatformNotificationTurnOn,
    isSMSNotificationTurnOn,
    t,
  ]);

  return (
    <ShareableLinkLockScreen
      className={classes}
      image={WaitingImage}
      title={t('waitingRoom')}
      description={t('yourAccessIsBeingReviewedByBroker', { communications })}
    />
  );
};

export default ShareableLinkWaitingRoom;
